import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import Button from 'react-bootstrap/esm/Button';
import Modal from 'react-bootstrap/esm/Modal';

const SaleTotalBranchOffice = _ => {
    const [isProcessing, setIsProccesing] = useState(true)
    const [rows, setRows] = useState([])

    useEffect(() => {
        setIsProccesing(true)
        Controllers.sale.get_sale_total().then(res => {
            setRows(res.data)
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setIsProccesing(false)
        })
    }, [])

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'key_branch_office', text: 'Sucursal', align: 'center' },
                { name: 'total_doc', text: 'Total Neto', align: 'center' },
                { name: 'iva_doc', text: 'IVA', align: 'center' },
                { name: 'total_mxn', text: 'Total MX', align: 'center' },
                { name: 'total_usd', text: 'Total DLL', align: 'center' },
                { name: 'code_period', text: 'Periódo', align: 'center' },
            ],
        ]}
        rows={rows}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    return <div className="ui-page">
        <div className="ui-page-head">
            <div>
                <h1 className="ui-page-title">Ventas Totales por Sucursal</h1>
                <p className="ui-page-meta">{isProcessing ? 'Cargando…' : `${rows.length} registro${rows.length === 1 ? '' : 's'}`}</p>
            </div>
        </div>
        <Card className="ui-list-shell border-0">
            <Card.Header>
                <span>Resultados</span>
            </Card.Header>
            <Card.Body>
                { dtRows }
            </Card.Body>
        </Card>
    </div>
}

export default SaleTotalBranchOffice